import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Image:", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Icon:", -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Titre:", -1)
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Sous titre:", -1)
const _hoisted_19 = { key: 4 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Categorie article:", -1)
const _hoisted_21 = { key: 5 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Alias:", -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { key: 6 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Contenu:", -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 7 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Meta title:", -1)
const _hoisted_29 = { key: 8 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "MetaKeyWord:", -1)
const _hoisted_31 = { key: 9 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "MetaDescription:", -1)
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { key: 10 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Date publication:", -1)
const _hoisted_36 = { key: 11 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Source:", -1)
const _hoisted_38 = { key: 12 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Est publié:", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, [
  /*#__PURE__*/_createTextVNode("Tag: "),
  /*#__PURE__*/_createElementVNode("p", null, "(Cliquez sur l'icône pour supprimer un tag)")
], -1)
const _hoisted_41 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Images / Vidéos ", -1)
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "blog-card style1" }
const _hoisted_48 = ["href"]
const _hoisted_49 = { class: "blog-img" }
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 0,
  class: "youtube-video"
}
const _hoisted_52 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-articles",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.article?.urlImage)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForFiles(_ctx.article.urlImage),
                        alt: "Image",
                        width: "200",
                        height: "200"
                      }, null, 8, _hoisted_11)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.icone)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForFiles(_ctx.article.icone),
                        alt: "Image",
                        width: "200",
                        height: "200"
                      }, null, 8, _hoisted_14)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.titre)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.titre), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.sousTitre)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.sousTitre), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.categorieArticle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.categorieArticle.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.alias)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("td", {
                      innerHTML: _ctx.article.alias
                    }, null, 8, _hoisted_23)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.contenu)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("td", {
                      innerHTML: _ctx.article?.contenu
                    }, null, 8, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.metaTitle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.metaTitle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.metaKeyword)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.metaKeyword), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.metaDescription)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("td", {
                      innerHTML: _ctx.article?.metaDescription
                    }, null, 8, _hoisted_33)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.datePublication)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.datePublication), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.source)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article?.source), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.article?.estPublie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("td", null, _toDisplayString(_ctx.article.estPublie), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_40,
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article?.articletags, (articletag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: articletag.id,
                        class: "badge-container"
                      }, [
                        _createElementVNode("span", _hoisted_41, [
                          _createTextVNode(_toDisplayString(articletag.tag.nom) + " ", 1),
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            class: "tag-delete-link text-outline-danger",
                            onClick: ($event: any) => (_ctx.suppression(articletag.id, _ctx.article?.articletags, 'articletag', `le tag ${articletag.tag.nom}`))
                          }, _hoisted_44, 8, _hoisted_42)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_45,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articlees, (articlee, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-xl-4 col-lg-6 col-md-6",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("a", {
                            href: _ctx.getUrlApiForFiles(articlee.type),
                            target: "_blank",
                            "data-lightbox": "gallery"
                          }, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("img", {
                                src: _ctx.getUrlApiForFiles(articlee.type),
                                alt: "Image"
                              }, null, 8, _hoisted_50)
                            ])
                          ], 8, _hoisted_48)
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.article?.source)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("iframe", {
                          src: _ctx.getYoutubeUrl(_ctx.article?.source),
                          frameborder: "0",
                          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: ""
                        }, null, 8, _hoisted_52)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}